import { Injectable } from "@angular/core";
@Injectable()
export class HmheadDocTypes {
    public CONTRACT    = 1;
    public RETURN      = 2;
    public DELIVERY    = 3;
    public CHANGEOVER  = 4;
    public ADJUSTMENT  = 5;
    public DELETION    = 6;
    public OFFHIRE     = 7;
    public HANDOVER    = 11;     
    public STRIKE      = 12;        
    public COLLECTION  = 27;
    public REV_OFFHIRE = 17;
    public REV_COLLECTION = 37;
    public TRANSFER_FROM_SITE = 18;
    public TRANSFER_TO_SITE = 19;       
    public INVOICE     = 20;
    public CASH_INVOICE = 21;
    public CREDIT_NOTE = 22;
    public BREAKDOWN = 8;
    public BREAKDOWN_COLLECTION = 128;
    
}
